import axios, { AxiosError } from 'axios'
import { PATHS } from 'const'
import { ICatalogo, IEmpresa, IGenero, ITipoCliente, ITipoDocumento } from 'types'

const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL,
    headers: {
        Authorization: `Bearer ${process.env.REACT_APP_SECURITY_API_KEY}`,
    },
})

export const getTipoDocumentoListService = async () => {
    try {
        const response = await instance.get(PATHS.CATALOGO_PATH + PATHS.TIPO_DOCUMENTO_PATH)
        return response.data as ITipoDocumento[]
    } catch (error) {
        throw new Error((error as AxiosError).message)
    }
}

export const getGeneroListService = async () => {
    try {
        const response = await instance.get(PATHS.CATALOGO_PATH + PATHS.GENERO_PATH)
        return response.data as IGenero[]
    } catch (error) {
        throw new Error((error as AxiosError).message)
    }
}

export const getEmpresaListService = async () => {
    try {
        const response = await instance.get(PATHS.CATALOGO_PATH + PATHS.EMPRESA_PATH)
        return response.data as IEmpresa[]
    } catch (error) {
        throw new Error((error as AxiosError).message)
    }
}


export const getTipoClienteListService = async () => {
    try {
        const response = await instance.get(PATHS.CATALOGO_PATH + PATHS.TIPO_CLIENTE_PATH)
        return response.data as ITipoCliente[]
    } catch (error) {
        throw new Error((error as AxiosError).message)
    }
}


export const getCategoriaListService = async () => {
    try {
        const response = await instance.get(PATHS.CATALOGO_PATH + PATHS.CATEGORIA_PATH)
        return response.data as ICatalogo[]
    } catch (error) {
        throw new Error((error as AxiosError).message)
    }
}

export const getEquipoListService = async () => {
    try {
        const response = await instance.get(PATHS.CATALOGO_PATH + PATHS.EQUIPO_PATH)
        return response.data as ICatalogo[]
    } catch (error) {
        throw new Error((error as AxiosError).message)
    }
}
